import { ImagePlus, Replace, Trash2, Upload } from "lucide-react";

const catalogApi = `${process.env.REACT_APP_BACKEND_URL}/api/catalog`;

const minimumDimension = 128;

export default function CatalogImageField({
  assetMeta,
  imageId,
  imageType,
  label,
  onRemove,
  onUpload,
  uploading,
}) {
  const metadata = assetMeta[imageId] || {};
  const isSmall =
    metadata.width &&
    metadata.height &&
    (metadata.width < minimumDimension || metadata.height < minimumDimension);

  const receiveFile = (file) => {
    if (file) {
      onUpload(file);
    }
  };

  return (
    <div
      className="catalog-image-field"
      data-testid={`catalog-image-field-${imageType}`}
    >
      <div className="catalog-image-field-heading">
        <strong>{label}</strong>
        <span>{imageType.replaceAll("_", " ")}</span>
      </div>
      <label
        className={`catalog-image-dropzone ${imageId ? "has-image" : ""}`}
        onDragOver={(event) => event.preventDefault()}
        onDrop={(event) => {
          event.preventDefault();
          receiveFile(event.dataTransfer.files?.[0]);
        }}
        data-testid={`catalog-image-dropzone-${imageType}`}
      >
        {imageId ? (
          <img
            src={`${catalogApi}/assets/${imageId}`}
            alt={`${label} preview`}
          />
        ) : (
          <span className="catalog-image-dropzone-empty">
            <ImagePlus size={20} />
            Drop image or browse
          </span>
        )}
        <input
          accept=".png,.jpg,.jpeg,.webp,.svg"
          onChange={(event) => receiveFile(event.target.files?.[0])}
          type="file"
          data-testid={`catalog-upload-${imageType}`}
        />
      </label>
      {imageId ? (
        <div className="catalog-image-meta">
          <span>
            {metadata.width && metadata.height
              ? `${metadata.width} × ${metadata.height}px`
              : "Stored catalog asset"}
          </span>
          {metadata.fileSize && (
            <span>{Math.ceil(metadata.fileSize / 1024)} KB</span>
          )}
          {isSmall && <b>Small at compact icon sizes</b>}
          <div>
            <label
              className="catalog-inline-upload"
              data-testid={`catalog-replace-${imageType}`}
            >
              <Replace size={13} /> Replace
              <input
                accept=".png,.jpg,.jpeg,.webp,.svg"
                onChange={(event) => receiveFile(event.target.files?.[0])}
                type="file"
              />
            </label>
            <button
              onClick={onRemove}
              type="button"
              data-testid={`catalog-remove-${imageType}`}
            >
              <Trash2 size={13} /> Remove
            </button>
          </div>
        </div>
      ) : (
        <span className="catalog-image-help">
          <Upload size={13} /> PNG transparency is preserved. Minimum 128px
          recommended.
        </span>
      )}
      {uploading && (
        <span className="catalog-image-uploading">Uploading image…</span>
      )}
    </div>
  );
}
